module.exports = __webpack_public_path__ + "e6a1f495045a32c14179099610cc7c44.png";